import React, { useCallback } from 'react'
import { useMuiSelectUtils } from 'scenes/Dashboard/components-next/Inputs/Select/Select.hook'
import { makeStyles } from 'tss-react/mui'

import { MenuItem, Select, SelectChangeEvent, Theme } from '@mui/material'

import { IsValidFilter } from '../../duck/types'

export type IsValidProps = {
  isValid: IsValidFilter
  onChange: (newSearch: IsValidFilter) => void
}

export const IsValidSelector = React.memo(({ onChange, isValid: isValid }: IsValidProps) => {
  const { classes } = useStyles()

  const menuItemsData = React.useMemo(
    () => [
      { value: IsValidFilter.all, text: 'Is Valid?' },
      { value: IsValidFilter.isValid, text: 'Is Valid' },
      { value: IsValidFilter.isNotValid, text: 'Is Not Valid' },
      { value: IsValidFilter.unknown, text: 'Unknown' },
    ],
    []
  )
  const { getItem, selectedItem, setSelectedItem } = useMuiSelectUtils(menuItemsData, isValid)
  const onSelectChange = useCallback(
    (event: SelectChangeEvent<{ name?: string; value: unknown }>) => {
      const isValid = event.target.value as IsValidFilter
      onChange(isValid)
      setSelectedItem(isValid)
    },
    [onChange]
  )

  return (
    <Select
      variant="standard"
      className={classes.field}
      renderValue={() => getItem(selectedItem)?.text}
      onChange={onSelectChange}
      value={getItem(selectedItem)}
    >
      {menuItemsData.map((m) => (
        <MenuItem key={m.value} value={m.value}>
          {m.text}
        </MenuItem>
      ))}
    </Select>
  )
})

IsValidSelector.displayName = 'IsValid'

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  field: {
    marginLeft: spacing(2),
  },
}))
